import store from '@/store'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import LoginView from '../views/LoginView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'login',
    meta:{
      title:"育网云盘-登录"
    },
    component: LoginView
  },
  {
    path: '/index',
    name: 'IndexView',
    meta:{
      title:"育网云盘-云盘",
      requireAuth:true
    },
    component: () => import('../views/IndexView.vue')
  },
  {
    path: '/images',
    name: 'ImagesView',
    meta:{
      title:"育网云盘-图片",
      requireAuth:true
    },
    component: () => import('../views/ImagesView.vue')
  },
  {
    path: '/folder',
    name: 'FileFolder',
    meta:{
      title:"育网云盘-文件列表",
      requireAuth:true
    },
    component: () => import('../views/FileFolder.vue')
  },
  {
    path: '/afolder',
    name: 'aFileFolder',
    meta:{
      title:"育网云盘-文件列表",
      requireAuth:true
    },
    component: () => import('../views/aFileFolder.vue')
  },
  {
    path: '/afolderlist',
    name: 'aFileFolderlist',
    meta:{
      title:"育网云盘-文件列表",
      requireAuth:true
    },
    component: () => import('../views/aFileFolderlist.vue')
  },
  {
    path: '/aOpenfolder',
    name: 'aOpenfolder',
    meta:{
      title:"育网云盘-个人网盘详情",
      requireAuth:true
    },
    component: () => import('../views/aOpenfolder.vue')
  },
  {
    path: '/aopenfolderlist',
    name: 'aOpenfolderlist',
    meta:{
      title:"育网云盘-网盘信息",
      requireAuth:true
    },
    component: () => import('../views/aOpenfolderlist.vue')
  },
  {
    path: '/sharefiles',
    name: 'ShareFile',
    meta:{
      title:"育网云盘-文件分享",
      requireAuth:true
    },
    component: () => import('../views/ShareFile.vue')
  },
  {
    path: '/fileslook',
    name: 'FilesLook',
    meta:{
      title:"育网云盘-文件分享",
      requireAuth:true
    },
    component: () => import('../views/FilesLook.vue')
  },
 
  {
    path: '/opendisk',
    name: 'OpenDisk',
    meta:{
      title:"育网云盘-网盘信息",
      requireAuth:true
    },
    component: () => import('../views/opendisk.vue')
  },
  {
    path: '/doubin',
    name: 'DouBinView',
    meta:{
      title:"育网云盘-网盘信息",
      requireAuth:true
    },
    component: () => import('../views/DouBin.vue')
  },
  {
    path: '/shareFolder',
    name: 'shareFolder',
    meta:{
      title:"育网云盘-网盘信息",
      requireAuth:true
    },
    component: () => import('../views/ShareFolder.vue')
  },
  {
    path: '/shareopendisk',
    name: 'ShareOpenDisk',
    meta:{
      title:"育网云盘-网盘信息",
      requireAuth:true
    },
    component: () => import('../views/ShareOpenDisk.vue')
  },

  {
    path: '/opendisklist',
    name: 'OpenDisklist',
    meta:{
      title:"育网云盘-网盘信息",
      requireAuth:true
    },
    component: () => import('../views/opendisklist.vue')
  },
  {
    path: '/myview',
    name: 'MyView',
    meta:{
      title:"育网云盘-个人中心",
      requireAuth:true
    },
    component: () => import('../views/myView.vue')
  },
  {
    path: '/myspace',
    name: 'MySpace',
    meta:{
      title:"育网云盘-文件统计",
      requireAuth:true
    },
    component: () => import('../views/mySpace.vue')
  },
  {
    path: '/myKongjian',
    name: 'myKongjian',
    meta:{
      title:"育网云盘-空间统计",
      requireAuth:true
    },
    component: () => import('../views/myKongjian.vue')
  },
  {
    path: '/changePwd',
    name: 'changePwd',
    meta:{
      title:"育网云盘-修改密码",
      requireAuth:true
    },
    component: () => import('../views/changePwd.vue')
  }
  ,
  {
    path: '/myUplist',
    name: 'myUplist',
    meta:{
      title:"育网云盘-我上传的",
      requireAuth:true
    },
    component: () => import('../views/myUplist.vue')
  },
  {
    path: '/mysearch',
    name: 'mySearch',
    meta:{
      title:"育网云盘-我的搜索",
      requireAuth:true
    },
    component: () => import('../views/mySearch.vue')
  },
  {
    path: '/allindex',
    name: 'allIndex',
    meta:{
      title:"育网云盘-全部",
      requireAuth:true
    },
    component: () => import('../views/allIndex.vue')
  },
  {
    path: '/myCollect',
    name: 'myCollect',
    meta:{
      title:"育网云盘-我的收藏",
      requireAuth:true
    },
    component: () => import('../views/myCollect.vue')
  },
  {
    path: '/myPersion',
    name: 'myPersion',
    meta:{
      title:"育网云盘-个人信息",
      requireAuth:true
    },
    component: () => import('../views/myPersion.vue')
  },
  {
    path: '/myLog',
    name: 'myLog',
    meta:{
      title:"育网云盘-我的日志",
      requireAuth:true
    },
    component: () => import('../views/myLog.vue')
  },
  {
    path: '/myShare',
    name: 'myShare',
    meta:{
      title:"育网云盘-我的分享",
      requireAuth:true
    },
    component: () => import('../views/myShare.vue')
  },
  {
    path: '/myGroup',
    name: 'myGroup',
    meta:{
      title:"育网云盘-群组管理",
      requireAuth:true
    },
    component: () => import('../views/myGroup.vue')
  },
  {
    path: '/myMessage',
    name: 'myMessage',
    meta:{
      title:"育网云盘-信息管理",
      requireAuth:true
    },
    component: () => import('../views/myMessage.vue')
  },
  {
    path: '/myMessagesend',
    name: 'myMessagesend',
    meta:{
      title:"育网云盘-发布信息管理",
      requireAuth:true
    },
    component: () => import('../views/myMessagesend.vue')
  },  
  {
    path: '/myMessageresive',
    name: 'myMessageresive',
    meta:{
      title:"育网云盘-接收信息管理",
      requireAuth:true
    },
    component: () => import('../views/myMessageresive.vue')
  },
  {
    path: '/myMessagedoubin',
    name: 'myMessagedoubin',
    meta:{
      title:"育网云盘-回收信息管理",
      requireAuth:true
    },
    component: () => import('../views/myMessagedoubin.vue')
  },
  {
    path: '/wk',
    name: 'CourseListen',
    meta:{
      title:"育网云盘-课程",
      requireAuth:true
    },
    component: () => import('../views/CourseListen.vue')
  },
  {
    path: '/courselist',
    name: 'CourseList',
    meta:{
      title:"育网云盘-课程列表",
      requireAuth:true
    },
    component: () => import('../views/CourseList.vue')
  },
  {
    path: '/cdetails',
    name: 'CourseDetails',
    meta:{
      title:"育网云盘-课程详情",
      requireAuth:true
    },
    component: () => import('../views/CourseDetails.vue')
  },
  {
    path: '/zyk',
    name: 'ResourceIndex',
    meta:{
      title:"育网云盘-资源页面",
      requireAuth:true
    },
    component: () => import('../views/ResourceIndex.vue')
  },
  {
    path: '/rdetails',
    name: 'ResourceDetails',
    meta:{
      title:"育网云盘-资源详情",
      requireAuth:true
    },
    component: () => import('../views/ResourceDetails.vue')
  }  ,
  {
    path: '/rlist',
    name: 'ResourceList',
    meta:{
      title:"育网云盘-资源列表",
      requireAuth:true
    },
    component: () => import('../views/ResourceList.vue')
  }
  ,
  {
    path: '/xc',
    name: 'XiangCe',
    meta:{
      title:"育网云盘-相册资源",
      requireAuth:true
    },
    component: () => import('../views/xiangce.vue')
  }
  
]
const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes
// })
// 全局前置守卫：任何页面的访问都要经过这里
// to：要去哪里的路由信息
// from：从哪里来的路由信息
// next：通行的标志
router.beforeEach((to, from, next) => {
  document.title =  '管理平台';
  // to.matched 是一个数组（匹配到是路由记录）
  // to.matched.some(record => record.meta.requiresAuth)
    if (to.meta.requiresAuth) {
    if (!store.state) {
      // 跳转到登录页面
      next({
        name: 'login',
        query: { // 通过 url 传递查询字符串参数
          redirect: to.fullPath // 把登录成功需要返回的页面告诉登录页面
        }
      })
    } else {
      next() // 允许通过
    }
  } else {
    next() // 允许通过
  }
})
export default router
